/**
 * Shared styling for error Alerts (matches ~16px rounded inputs used in the app).
 * Outlined, red border, white fill — generic copy for backend / network failures.
 */

export const GENERIC_ERROR_MESSAGE =
  "Something went wrong. Please try again later or contact App Support if the issue continues.";

export const appErrorAlertSx = {
  borderRadius: "16px",
  mt: "10px",
  mx: "10px",
  mb: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
  bgcolor: "#ffffff",
  color: "text.primary",
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "error.main",
  "& .MuiAlert-icon": {
    color: "error.main",
  },
  "& .MuiAlertTitle-root": {
    color: "error.main",
    fontWeight: 600,
  },
};
